import { Theme, Components } from '@mui/material/styles';

export const SvgIconOverrides: Components<Theme> = {
  MuiSvgIcon: {
    defaultProps: {
      viewBox: '0 0 16 16',
      sx: {
        height: 16,
        width: 16,
      },
    },
    styleOverrides: {},
  },
};
